import type { MockClaimCard } from "@/shared/mock-data";
import { SUB_AGENT_CONFIGS } from "@/shared/sub-agents";

interface RichClaimCardsProps {
  claims: MockClaimCard[];
}

export function RichClaimCards({ claims }: RichClaimCardsProps) {
  return (
    <div className="grid gap-3 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {claims.map((claim) => (
        <article
          key={claim.id}
          className="rounded-xl border bg-card p-4 space-y-2"
        >
          <div className="flex items-center justify-between">
            <p className="font-semibold text-sm">{claim.claimNumber}</p>
            <span className="text-xs px-2 py-1 rounded-full bg-secondary">
              {claim.priority}
            </span>
          </div>
          <p className="text-sm">{claim.insuredName}</p>
          <p className="text-xs text-muted-foreground">
            {claim.lossType} • {claim.status}
          </p>
          <p className="text-sm font-medium">{claim.estimatedLoss}</p>
          <div className="flex flex-wrap gap-1 pt-1">
            {claim.assignedSubAgents.map((agentId) => {
              const label =
                SUB_AGENT_CONFIGS.find((agent) => agent.id === agentId)?.name ??
                agentId;
              return (
                <span
                  key={agentId}
                  className="text-xs px-2 py-1 rounded bg-blue-50 text-blue-700 border border-blue-100"
                >
                  {label}
                </span>
              );
            })}
          </div>
        </article>
      ))}
    </div>
  );
}
